import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

    // /**************************************************************
    // -> Pageload animation
    // **************************************************************/
    function pageTaxoTypeLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-taxonomy-type .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-taxonomy-type .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-taxonomy-type .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    }
    pageTaxoTypeLoadAnimation()

    /**************************************************************
    -> Taxonomy Type intro anim on scroll
    **************************************************************/
    function inViewAnimIntroTaxoType() {
      gsap.fromTo('.intro-taxonomy-type-landing .intro-container h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-taxonomy-type-landing .intro-container',
      })

      gsap.fromTo('.intro-taxonomy-type-landing .intro-container p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-taxonomy-type-landing .intro-container',
      })

    }
    inViewAnimIntroTaxoType();

    /**************************************************************
    -> Taxonomy Type intro anim on scroll
    **************************************************************/
    function inViewAnimFiltersTaxoType() {
      gsap.fromTo('.filters-taxonomy-type-landing .wrap-title-and-filters' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-taxonomy-type-landing .wrap-title-and-filters',
      })
    }
    inViewAnimFiltersTaxoType();

    /**************************************************************
    -> Experiences List anim on scroll
    **************************************************************/
    function inViewAnimListExperiencesTaxoType() {
      gsap.fromTo('.experiences-list-type-taxonomy .wrap-experiences-list .experience-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.2,
        stagger: {
          each: 0.01,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.experiences-list-type-taxonomy .wrap-experiences-list',
      })

      // ScrollTrigger.matchMedia({
	
      //   // desktop
      //   '(min-width: 800px)': function() {
      //     gsap.fromTo('.experiences-list-type-taxonomy .wrap-experiences-list .experience-item' , 
      //     { opacity: 0 },
      //     {
      //       opacity: 1,
      //       delay: 0.5,
      //       duration: 0.5,
      //       stagger: {
      //         each: 0.05,
      //         from: 'start',
      //         grid: 'auto',
      //         ease: 'linear',
      //       },
      //       scrollTrigger: '.experiences-list-type-taxonomy .wrap-experiences-list',
      //     })
      //   },
      
      //   // mobile
      //   '(max-width: 799px)': function() {
      //     gsap.fromTo('.experiences-list-type-taxonomy .wrap-experiences-list .experience-item' , 
      //     { opacity: 0 },
      //     {
      //       opacity: 1,
      //       delay: 0.5,
      //       duration: 0.1,
      //       stagger: {
      //         each: 0.01,
      //         from: 'start',
      //         grid: 'auto',
      //         ease: 'linear',
      //       },
      //       scrollTrigger: '.experiences-list-type-taxonomy .wrap-experiences-list',
      //     })
      //   },
        
      // }); 

    }
    inViewAnimListExperiencesTaxoType();

    /**************************************************************
    -> Show hide sub filter if first filter has a choice
    **************************************************************/
    $(document).on('facetwp-loaded', function() {
      const countriesSubFilter = document.querySelector('.sub-sorting-by-countries');
      // eslint-disable-next-line no-undef
      if (FWP) {
        // eslint-disable-next-line no-undef
        if (FWP.facets.by_destination.length === 0) {
          countriesSubFilter.classList.remove('active')
        }
         else {
           // eslint-disable-next-line no-undef
          countriesSubFilter.classList.add('active')

          // eslint-disable-next-line no-undef
          if (FWP.facets.by_destination[0] === 'ireland') {
            countriesSubFilter.classList.remove('active')
          }
        }
      }
    });

    /**************************************************************
    -> Clear Subfilter if Main filter is reset or refilter
    **************************************************************/
    $(document).on('facetwp-refresh', function() {
      // eslint-disable-next-line no-undef
      if (FWP.facets['by_destination'].length === 0) {
        // eslint-disable-next-line no-undef
        FWP.facets['by_countries'] = [];
      }

    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/type-data.js